
<div class="live-test">
  <div class="landing-page-template cupcakeFactory">
    <ng-container *ngFor="let item of newLanding; let i = index" [ngComponentOutlet]="getComponent(item.landingType, item.moduleType)"></ng-container>
  </div>
</div>
